// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"60514501","513":"65836e7c","703":"b63d104c"}[chunkId] + ".chunk.js";
};